<template>
  <div style="overflow: hidden; height: 0"/>
</template>

<script setup>
import html2canvas from "html2canvas";
import {jsPDF} from "jspdf";
import {onMounted, reactive, ref, defineEmits, defineProps, defineExpose} from "vue";

const props = defineProps({
  mode: String,
  flnm: String,
});

const emits = defineEmits(['compt']);

/* mode
* create: 파일 생성
* download: 파일 생성 후 다운로드
* */
const mode = ref('create');
const pages = ref([]);
const isCreatePdf = ref(false);
const printPadding = reactive({
  top: 80,
  right: 40,
  bottom: 80,
  left: 40,
});
const drawInterVal = ref(null);

const drawCanvas = async (pageElement, pageIndex) => {
  const dpi = 300;
  const scale = 2;
  const canvas = await html2canvas(pageElement, {
    dpi: dpi,
    scale: scale,
    scrollX: 0,
    scrollY: 0,
  });

  let page  = pages.value[pageIndex];
  page.dataURL = canvas.toDataURL("image/png");
  page.width = canvas.width;
  page.height = canvas.height;
  page.isSet = true;
}

const drawCanvasToPdf = async (targetElement, params) => {
  pages.value = [];

  const printPages = Array.from(targetElement.getElementsByClassName("print_page"));

  printPages.forEach((pageElement, index) => {
      pageElement.style.padding =
              printPadding.top + "px " +
              printPadding.right + "px " +
              printPadding.left + "px ";

      pages.value.push({
        isSet: false,
        dataURL: null,
        width: null,
        height: null,
      });

      drawCanvas(pageElement, index);
    }
  );

  drawInterVal.value = setInterval(async () => {
    let cnt = 0;

    const isSetPages = pages.value.filter(({isSet}) => isSet == true);
    cnt += isSetPages.length;

    if (pages.value.length == cnt && !isCreatePdf.value) {
      isCreatePdf.value = true;

      const doc = new jsPDF({
        orientation: "p",
        unit: "mm",
        format: "a4",
        compressPdf: true,
      });

      const imgWidth = 210;

      pages.value.forEach((page, index) => {
        let imgHeight = (page.height * imgWidth) / page.width;
        if (index > 0) doc.addPage();

        doc.addImage(page.dataURL, "PNG", 0, 0, imgWidth, imgHeight, "image" + index, "SLOW");
      })

      clearInterval(drawInterVal.value);

      isCreatePdf.value = false;

      let flnm = "test";
      if (props.flnm != null) flnm = props.flnm;
      doc.save(flnm + ".pdf");

      await emits('compt', doc.output("blob"), params);
    }
  }, 1000);
}

defineExpose({
  drawCanvasToPdf
})

onMounted(() => {
  if (props.mode) mode.value = props.mode;
})
</script>

<style scoped>

</style>